// @flow

import React from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';

import FileUpload from '../FileUpload/FileUpload';

const FORM_NAME = 'book';

function NewBook() {
  return (
    <div>
      <FieldArray
        formName={FORM_NAME}
        name="files"
        props={{
          maxLength: 1,
          maxSize: 25,
          accept: 'application/pdf',
        }}
        component={FileUpload}
        label="Файл с PDF-книгой"
      />
    </div>
  )
}

export default reduxForm({
  form: FORM_NAME
})(NewBook)



// WEBPACK FOOTER //
// ./src/components/Book/NewBook.js